import React, { Component } from 'react';

import Parse from 'parse';
import moment from 'moment';

import DatePicker from 'material-ui/DatePicker';
import TimePicker from 'material-ui/TimePicker';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import CircularProgress from 'material-ui/CircularProgress';
import IconButton from 'material-ui/IconButton';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import TextField from 'material-ui/TextField';
import { List, ListItem } from 'material-ui/List';

import Add from 'material-ui/svg-icons/content/add-circle-outline'
import Delete from 'material-ui/svg-icons/action/delete';

import ChipInput from 'material-ui-chip-input'

import * as Colors from '../../../styles/colors';
import * as ParseService from '../../../services/parse';
import ObjectStore from '../../../services/object-store';
import Utils from '../../../services/utils';

function AssignmentAddTasks(props) {
  return (
    <div>
      <div className='add-task-box'>
        <TextField
          id='add-assignment-task'
          name='task'
          hintText='New Task...'
          onChange={props.onChange}
          value={props.newTask}
          onKeyPress={props.onNewTaskReturn}
          style={{marginRight: '10px'}}
          underlineShow={false} />

        <IconButton 
          onClick={props.onTaskAdd} 
          disabled={props.newTask.length === 0}>
          <Add color={Colors.peterRiver} />
        </IconButton>
      </div>

      <List>
        {props.tasks.map((task, index) =>
          <ListItem
            key={task.id}
            primaryText={task.get('text')}
            rightIconButton={<IconButton onClick={() => props.onTaskDelete(task, index)}><Delete color={Colors.secondaryTextBlack}/></IconButton>}
            disabled={true} />
        )}
      </List>
    </div>
  );
}

function AssignmentAddAlarm(props) {
  const alarms = [];
  alarms.push((
    <MenuItem
      key={1000}
      label={null}
      value={null}
      primaryText="None" />
  ));

  [0, 1, 2, 3, 4, 5, 6, 7].map((offset) =>
    alarms.push((
      <MenuItem
        key={offset}
        label={offset}
        value={offset}
        primaryText={Utils.alarmOffsetIdentifier(offset)} />
    ))
  );

  return alarms;
}

class AssignmentAddDetail extends Component {

  constructor(props) {
    super(props);

    var assignment = props.assignment;
    if (assignment === undefined || assignment === null) {
      assignment = ObjectStore.buildAssignment();
    }

    this.state = {
      assignment: assignment,
      relationTags: [],
      courses: [],
      tags: [],
      newTask: '',
      isLoading: true,
      archivedObjects: [],
    };
  }

  componentDidMount() {
    const assignment = this.state.assignment;
    const that = this;

    const courseQuery = ParseService.findCourses();
    const tagQuery = ParseService.findTags();
    const tagRelationQuery = assignment.relation('tags').query().find();

    Parse.Promise.when([courseQuery, tagQuery, tagRelationQuery]).then(
      function(results) {
        that.setState({
          courses: results[0],
          tags: results[1],
          relationTags: results[2],
          isLoading: false,
        });
      },
      function(err) {
        console.log('Failed to find objects ' + err);
        that.setState({
          isLoading: false
        });
      }
    );
  }

  formatDate(date) {
    return moment(date).format('ddd, l');
  }
  
  handleAlarmChange = (event, index, offset) => {
    const assignment = this.state.assignment;
    if (offset === null && assignment.get("alarm") !== undefined) {
      var alarm = assignment.get('alarm');
      ParseService.archive(alarm);
      this.state.archivedObjects.push(alarm);

      assignment.unset('alarm');
    } else {
      if (assignment.get('alarm') === null || assignment.get('alarm') === undefined) {
        var alarm = ObjectStore.buildAlarm(assignment.get('dueAt'), offset);
        alarm.set('body', Utils.alarmBody(assignment.get('title'), assignment.get('dueAt')));
        
        assignment.set('alarm', alarm);
      } else {
        var alarm = assignment.get('alarm');
        alarm.set('fireDate', Utils.alarmFireDate(assignment.get('dueAt'), offset, alarm.get('fireDate')));
        alarm.set('referenceDayOffset', offset);
      }
    }

    this.forceUpdate();
  }

  handleAlarmFireDateChange = (e, fireTime) => {
    const assignment = this.state.assignment;
    const alarm = assignment.get('alarm');

    var fireDate = Utils.alarmFireDate(assignment.get('dueAt'), 
                    alarm.get('referenceDayOffset'), 
                    fireTime);
    alarm.set('fireDate', fireDate);

    this.forceUpdate();
  }

  handleCourseChange = (event, index, value) => {
    if (index === 0) {
      this.state.assignment.unset('course');
    } else {
      this.state.assignment.set('course', this.state.courses[index - 1]);
    }

    this.forceUpdate();
  }

  handleDescriptionChange = (e, newValue) => {
    this.state.assignment.set('text', newValue);
    this.forceUpdate();
  }

  handleEffortChange = (event, index, value) => {
    this.state.assignment.set('effort', value);
    this.forceUpdate();
  }

  handleDueAtChange = (event, date) => {
    const assignment = this.state.assignment;
    assignment.set('dueAt', date);

    const alarm = assignment.get('alarm');
    if (alarm !== undefined && alarm !== null) {
        alarm.set('fireDate', Utils.alarmFireDate(date, alarm.get('referenceDayOffset'), alarm.get('fireDate')));
        alarm.set('body', Utils.alarmBody(assignment.get('title'), date));
    }

    this.forceUpdate();
  }

  handlePlannedAtChange = (event, date) => {
    this.state.assignment.set('plannedAt', date);

    this.forceUpdate();
  }

  handleSubmit = () => {
    const that = this;
    
    const assignment = this.state.assignment;
    const relationTags = this.state.relationTags;
    const archivedObjs = this.state.archivedObjects;

    const unsavedTags = []; 
    relationTags.forEach((tag) => {
      if (tag.id === undefined) {
        unsavedTags.push(tag);
      }
    });

    Parse.Object.saveAll(archivedObjs).then(
      function(result) {
        return Parse.Object.saveAll(unsavedTags);
      }
    ).then(
      function(savedTags) {
        savedTags.forEach((tag) => 
          assignment.relation('tags').add(tag)
        );
        
        return assignment.save();
      }
    ).then(
      function(result) {
        that.props.onSave(result);
      },
      function(err) {
        console.log("Failed to save Assignment " + err);
      }
    );
  }

  handleTagAdd = (chip) => {
    var tag = this.state.tags.find((tag) => {
      return tag.get('text').toUpperCase() === chip.toUpperCase()
    });

    if (tag === undefined) {
      tag = ObjectStore.buildTag();
      tag.set('text', chip);

      this.state.tags.push(tag);
      this.state.relationTags.push(tag);
    } else {
      // Only add this tag if it's not already added (can we use a set or hash here instead?).
      var relationTag = this.state.relationTags.find((tag) => {
        return tag.get('text').toUpperCase() === chip.toUpperCase()
      });

      if (relationTag === undefined) {
        this.state.relationTags.push(tag);
      } 

      if (tag.id !== undefined) {
        this.state.assignment.relation('tags').add(tag);
      }
    }

    this.forceUpdate();
  }

  handleTagDelete = (chip, index) => {
    const tag = this.state.tags[index];
    
    if (tag.id !== undefined) {
      this.state.assignment.relation('tags').remove(tag);  
    }
    
    const relationIndex = this.state.relationTags.findIndex((tag) => {
      return tag.get('text').toUpperCase() === chip.toUpperCase();
    });

    if (relationIndex !== -1) {
      this.state.relationTags.splice(index, 1);
    }

    this.forceUpdate();
  }

  handleTitleChange = (e, newValue) => {
    const assignment = this.state.assignment;
    assignment.set('title', newValue);

    const alarm = assignment.get('alarm');
    if (alarm !== undefined && alarm !== null) {
      alarm.set('body', Utils.alarmBody(newValue, alarm.get('fireDate')));
    }

    this.forceUpdate();
  }

  handleNewTaskReturn = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();

      this.handleTaskAdd();
    }
  }

  handleTaskAdd = () => {
    // Create a new task for this Assignment.
    if (this.state.newTask.length > 0) {
      const task = ObjectStore.buildTask();
      task.set('text', this.state.newTask);
      task.set('index', this.state.assignment.get('tasks').length);

      this.state.assignment.get('tasks').push(task);
      this.setState({newTask: ''});        
    }
  }

  handleTaskDelete = (task, index) => {
    const tasks = this.state.assignment.get('tasks');
    tasks.slice(index + 1).forEach(task => {
      task.set('index', task.get('index') - 1);
    });

    tasks.splice(index, 1);

    this.forceUpdate();
  }

  dialogTitle = (a) => {
    return a.id === null || a.id === undefined ? 'New Assignment' : 'Edit Assignment'; 
  }

  tagValues = () => {
    const tags = this.state.relationTags;
    if (tags === undefined || tags === null) {
      return [];
    }

    return tags.map((tag) => tag.get('text'));
  }

  render() {
    const actions = [
      <FlatButton
        label='Cancel'
        primary={true}
        onClick={this.props.onCancel} />,
      <FlatButton
        label='Save'
        primary={true}
        onClick={this.handleSubmit} />
    ];

    return (
      <Dialog
        title={this.dialogTitle(this.state.assignment)}
        actions={actions}
        open={this.props.open || true}
        onRequestClose={this.props.onCancel}
        autoScrollBodyContent={true}
        contentStyle={{maxWidth: '600px'}} >
        
        { this.state.isLoading ? (
          <div className='centered-progress-box'>
            <CircularProgress />
          </div>
        ) : (
          <form className='split-form-box' onSubmit={this.handleSubmit}>
            <div className='col'>
              <TextField
                id='add-assignment-title'
                name='title'
                floatingLabelText="Title"
                onChange={this.handleTitleChange}
                value={this.state.assignment.get('title')}
                fullWidth={true} />

              <TextField
                id='add-assignment-text'
                name='text'
                hintText='Description'
                onChange={this.handleDescriptionChange}
                value={this.state.assignment.get('text')}
                multiLine={true}
                fullWidth={true} />

              <ChipInput
                value={this.tagValues()}
                onRequestAdd={this.handleTagAdd}
                onRequestDelete={this.handleTagDelete}
                dataSource={this.state.tags.map((tag) => tag.get('text'))}
                hintText='Tags'
                fullWidth={true} />

              <SelectField
                floatingLabelText="Course"
                floatingLabelFixed={true}
                value={this.state.assignment.get('course') != null ? this.state.assignment.get('course').id : null}
                onChange={this.handleCourseChange}
                fullWidth={true}>

                <MenuItem
                  value={null}
                  primaryText='None' />

                {this.state.courses.map((course) => 
                  <MenuItem
                    key={course.id}
                    label={course.get('title')}
                    value={course.id}
                    primaryText={course.get('title')} />
                )}

              </SelectField>

              <div className='detail-item'>
                <div className='floating-label'>Due At</div>

                <DatePicker 
                  hintText="Due At"
                  value={this.state.assignment.get('dueAt')}
                  onChange={this.handleDueAtChange}
                  fullWidth={true}
                  formatDate={this.formatDate} />
              </div>

              
                <div className='detail-item detail-item-multiple--leading'>
                  <div className='floating-label'>Alarm</div>
              
                  <SelectField
                    value={this.state.assignment.get('alarm') !== undefined ? this.state.assignment.get('alarm').get('referenceDayOffset') : null}
                    onChange={this.handleAlarmChange} >

                    <MenuItem
                      key={1000}
                      label={null}
                      value={null}
                      primaryText="None" />
  
                    {[0, 1, 2, 3, 4, 5, 6, 7].map((offset) =>
                      <MenuItem
                        key={offset}
                        label={Utils.alarmOffsetIdentifier(offset)}
                        value={offset}
                        primaryText={Utils.alarmOffsetIdentifier(offset)} />
                    )}

                  </SelectField>

                  <TimePicker
                    hintText="Alarm Time"
                    pedantic={true}
                    defaultTime={this.state.assignment.get('alarm') !== undefined ? this.state.assignment.get('alarm').get('fireDate') : null}
                    disabled={this.state.assignment.get('alarm') === undefined}
                    value={this.state.assignment.get('alarm') !== undefined ? this.state.assignment.get('alarm').get('fireDate') : null}
                    onChange={this.handleAlarmFireDateChange} />
              
              </div>

              <div className='floating-label'>Planned At</div>

              <DatePicker 
                hintText="Planned At"
                value={this.state.assignment.get('plannedAt')}
                onChange={this.handlePlannedAtChange}
                fullWidth={true}
                formatDate={this.formatDate} />

              <SelectField
                floatingLabelText="Effort"
                value={this.state.assignment.get('effort')}
                onChange={this.handleEffortChange}
                fullWidth={true} >

                { [1,2,3,5,8].map((effort) =>
                  <MenuItem
                    key={effort}
                    label={effort}
                    value={effort}
                    primaryText={effort} />
                )}

              </SelectField>

            </div>

            <div className='col' style={{paddingTop: '16px'}}>
              <AssignmentAddTasks
                newTask={this.state.newTask}
                onTaskAdd={this.handleTaskAdd}
                onNewTaskReturn={this.handleNewTaskReturn}
                onChange={(e, newValue) => this.setState({newTask: newValue})}
                onTaskDelete={this.handleTaskDelete}
                tasks={this.state.assignment.get('tasks')}/>
            </div>
            
          </form>
        )}

      </Dialog>
    );
  }

}

export default AssignmentAddDetail;


// WEBPACK FOOTER //
// ./src/scenes/Assignments/components/AssignmentAddDetail.js